module.exports = __webpack_public_path__ + "img/arrow_right.7e1e87de.svg";